import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/TwitterVerificationToast.css';

const TwitterVerificationToast = () => {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const handleTwitterVerificationRequired = (event) => {
      setMessage(event.detail.message);
      setVisible(true);

      // Auto-hide after 8 seconds
      setTimeout(() => {
        setVisible(false);
      }, 8000);
    };

    window.addEventListener('twitterVerificationRequired', handleTwitterVerificationRequired);

    return () => {
      window.removeEventListener('twitterVerificationRequired', handleTwitterVerificationRequired);
    };
  }, []);

  const handleGoToSettings = () => {
    setVisible(false);
    navigate('/settings', { state: { scrollToTwitter: true } });
  };

  const handleClose = () => {
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="twitter-toast-overlay">
      <div className="twitter-toast">
        <div className="toast-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        </div>
        <div className="toast-content">
          <h4 className="toast-title">Twitter Verification Required</h4>
          <p className="toast-message">{message}</p>
          <div className="toast-actions">
            <button className="toast-btn toast-btn-primary" onClick={handleGoToSettings}>
              Go to Settings
            </button>
            <button className="toast-btn toast-btn-secondary" onClick={handleClose}>
              Dismiss
            </button>
          </div>
        </div>
        <button className="toast-close" onClick={handleClose} aria-label="Close">
          ×
        </button>
      </div>
    </div>
  );
};

export default TwitterVerificationToast;
